/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_DivisionsInputs */

const th_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดิวิชั่น`)
};

const en_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisions`)
};

const ja_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディビジョン`)
};

const zh_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分区`)
};

const es_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorías`)
};

const pt_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorias`)
};

const id_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi`)
};

const fr_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégories`)
};

const tl_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga dibisyon`)
};

const vi_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng`)
};

const ko_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디비전`)
};

const de_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassen`)
};

const ru_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивизионы`)
};

const tr_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruplar`)
};

const it_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorie`)
};

const pl_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupy`)
};

const uk_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивізіони`)
};

const hi_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्ग`)
};

const ar_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئات`)
};

const ms_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisyen`)
};

const bn_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিভাগ`)
};

const zh_tw2_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分組`)
};

const zh_hk2_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組別`)
};

const ur_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درجے`)
};

const fa_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گروه‌ها`)
};

const sw_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Madaraja`)
};

const nl_event_divisions = /** @type {(inputs: Event_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassen`)
};

/**
* | output |
* | --- |
* | "Divisions" |
*
* @param {Event_DivisionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_divisions = /** @type {((inputs?: Event_DivisionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_DivisionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_divisions(inputs)
	if (locale === "ja") return ja_event_divisions(inputs)
	if (locale === "zh") return zh_event_divisions(inputs)
	if (locale === "es") return es_event_divisions(inputs)
	if (locale === "pt") return pt_event_divisions(inputs)
	if (locale === "id") return id_event_divisions(inputs)
	if (locale === "fr") return fr_event_divisions(inputs)
	if (locale === "tl") return tl_event_divisions(inputs)
	if (locale === "vi") return vi_event_divisions(inputs)
	if (locale === "ko") return ko_event_divisions(inputs)
	if (locale === "de") return de_event_divisions(inputs)
	if (locale === "ru") return ru_event_divisions(inputs)
	if (locale === "tr") return tr_event_divisions(inputs)
	if (locale === "it") return it_event_divisions(inputs)
	if (locale === "pl") return pl_event_divisions(inputs)
	if (locale === "uk") return uk_event_divisions(inputs)
	if (locale === "hi") return hi_event_divisions(inputs)
	if (locale === "ar") return ar_event_divisions(inputs)
	if (locale === "ms") return ms_event_divisions(inputs)
	if (locale === "bn") return bn_event_divisions(inputs)
	if (locale === "zh-TW") return zh_tw2_event_divisions(inputs)
	if (locale === "zh-HK") return zh_hk2_event_divisions(inputs)
	if (locale === "ur") return ur_event_divisions(inputs)
	if (locale === "fa") return fa_event_divisions(inputs)
	if (locale === "sw") return sw_event_divisions(inputs)
	if (locale === "nl") return nl_event_divisions(inputs)
	return en_event_divisions(inputs)
});